let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Oj5y")).then(() => parcelRequire('2JKSZ'));